import angular from 'angular';

import reportsDataService from 'app/services/data/reports.data.service';
import directive from './view-archived-report.directive';
import controller from './view-archived-report.directive.controller';

export default angular.module('app.components.global.viewArchivedReport', [
  reportsDataService
])
  .directive('viewArchivedReport', directive)
  .controller('ViewArchivedReportDirectiveController', controller)
  .name;

console.log('app.components.global.viewArchivedReport created');
